/**
 * BLOC ARGUMENTS
 * Révélation à l'arrivée dans le viewport : l'entête d'abord, puis les arguments
 * en stagger depuis la gauche.
 */
jQuery(document).ready(function ($) {

    const DEPART_Y = 30      // pixels de montée
    const DUREE = .8         // durée de révélation d'un élément
    const STAGGER = .12      // décalage d'un argument au suivant
    const DEP_ARGUMENTS = .2 // départ des arguments, l'entête est encore en course

    // animations réduites : tout reste visible, aucun tween créé
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
        return

    $(".bloc_arguments").each(function () {
        const bloc = this
        const entete = bloc.querySelector(".texte")
        const arguments_ = gsap.utils.toArray(bloc.querySelectorAll(".arguments > *"))

        if (!entete && !arguments_.length)
            return

        /**
         * once: true — la révélation se joue une fois et le trigger se détruit.
         * Un scrub ferait disparaître les arguments en remontant la page, ce qui
         * n'a pas de sens sur des cartes de contenu.
         */
        const tl = gsap.timeline({
            defaults: { ease: "power2.out", force3D: true },
            scrollTrigger: {
                trigger: bloc,
                start: "top 75%",
                once: true
            }
        })

        if (entete) {
            tl.fromTo(entete,
                { opacity: 0, y: DEPART_Y },
                { opacity: 1, y: 0, duration: DUREE },
                0)
        }

        if (arguments_.length) {
            tl.fromTo(arguments_,
                { opacity: 0, y: DEPART_Y },
                { opacity: 1, y: 0, duration: DUREE, stagger: STAGGER },
                DEP_ARGUMENTS)
        }
    })

})
